import { Button } from '@/components/ui';
import { useWidgetCollapse } from '@/features/widgets/widget-context';

type FeedDelegatedButtonProps = {
  readonly count: number;
  readonly open: boolean;
  readonly onToggle: () => void;
};

export const FeedDelegatedButton = ({
  count,
  open,
  onToggle,
}: FeedDelegatedButtonProps) => {
  const section = useWidgetCollapse();
  return (
    <Button
      variant={open ? 'secondary' : 'ghost'}
      size="xs"
      textSize="sm"
      className="text-foreground-muted hover:text-foreground"
      aria-pressed={open}
      onClick={() => {
        if (!open && section.collapsed) section.toggle();
        onToggle();
      }}
    >
      Delegated {count}
    </Button>
  );
};
